import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

const el = '.js-c-logo--header--tracking'

on('click', el, event => {
  const anchorElement = event.target.closest(`a${el}`)

  if (anchorElement) {
    const track = createAnalyticsGroup("Logo (home link)")
    const clickValue = "Header"
    track('click', clickValue)
  }
})
